<template>
    <v-container>
        <div style="padding:10px; border-radius: 5px; background-color: #555; color: white;">
            Work Activities (Average Time)
        </div>    
        <br>  
                <div style="padding:10px; border-radius: 5px; background-color: #555; color: white;">
            <strong>Hours Sitting</strong> <br>   
            DAY :   {{forms.activities[0].model_day}} Hours  <br>
            WEEK :   {{forms.activities[0].model_week}} Hours <br>
            <br>
            <strong>Hours Standing</strong> <br>   
            DAY :   {{forms.activities[1].model_day}} Hours  <br>
            WEEK :   {{forms.activities[1].model_week}} Hours <br>
            <br>
            <strong>Hours Walking</strong> <br>   
            DAY :   {{forms.activities[2].model_day}} Hours <br> 
            WEEK :   {{forms.activities[2].model_week}} Hours<br>
            <br>
            <strong>Hours at Computer Station</strong> <br>
            DAY :   {{forms.activities[3].model_day}} Hours <br> 
            WEEK :   {{forms.activities[3].model_week}} Hours<br>
        </div>         <br>  <br>  <br>
              <div style="padding:10px; border-radius: 5px; background-color: #555; color: white;">
           Overall Summary
        </div>    
        <br>
        <div style="padding:10px; border-radius: 5px; background-color: #555; color: white;">
            Neck Score :  {{forms.neck_total}} <br>
            Wrist Score :  {{forms.wrist_total}} <br>
            Elbow Score :  {{forms.elbow_total}} <br>
            Back Score :  {{forms.back_total}} <br>
            Knee Score :  {{forms.knee_total}} <br>
            General Score :  {{forms.general_total}} <br>
            Final Score :  {{forms.percentage}}% <br>
              
        </div>      
    </v-container>
</template>
<script>
import db from '@/components/firebase.init';
import Slider from '@/components/Slider';
export default {
    props:['forms'],
    
    data(){
    
        return{
            
        }
    },
    methods:{
        
    },
    components:{
        'slider' : Slider
    }
}
</script>
